import styled from 'styled-components'

export const CalendarContainer = styled.div`
  width: 100%;

  .date-filter {
    max-width: unset !important;
  }

  .rdr-button-actions-container {
    display: none !important;
  }
`

export const CustomFilterDate = styled.div`
  margin: 4px auto 30px;
`
